<script setup>
import { computed } from "vue";
import { useStore } from "@/stores/index";
import SidenavList from "./SidenavList.vue";
import logo from "@/assets/img/logo-nurture.png";
import logoWhite from "@/assets/img/logo-nurture.png";
import image from "@/assets/img/profile-layout-header.jpg";

const store = useStore();
const isRTL = computed(() => store.isRTL);
const layout = computed(() => store.layout);
const sidebarType = computed(() => store.sidebarType);
const darkMode = computed(() => store.darkMode);
</script>
<template>
  <div
    v-if="layout === 'custom'"
    class="position-absolute w-100 min-height-300 top-0"
    :style="{
      'background-image': 'url(' + image + ')',
      'background-position-y': '50%',
    }"
  >
    <span class="mask bg-success opacity-6"></span>
  </div>
  <div
    v-show="layout === 'default'"
    class="min-height-300 position-absolute w-100"
    :class="`${darkMode ? 'bg-transparent' : 'bg-dark'}`"
  />

  <aside
    id="sidenav-main"
    class="sidenav navbar navbar-vertical navbar-expand-xs border-0 border-radius-xl my-3 ms-4"
    :class="` ${sidebarType} ${
      isRTL ? 'fixed-end me-3 rotate-caret' : 'fixed-start ms-3'
    } ${layout === 'landing' ? 'bg-transparent shadow-none' : ''}`"
  >
    <div class="sidenav-header">
      <i
        id="iconSidenav"
        class="top-0 p-3 cursor-pointer fas fa-times text-secondary opacity-5 position-absolute end-0 d-none d-xl-none"
        aria-hidden="true"
      ></i>
      <router-link class="m-0 navbar-brand" to="/">
        <img
          :src="
            layout === 'landing' || darkMode || sidebarType === 'bg-default'
              ? logoWhite
              : logo
          "
          class="navbar-brand-img h-100"
          alt="main_logo"
        />
        <span class="ms-2 font-weight-bold">Nurture Investors Portal</span>
      </router-link>
    </div>
    <hr class="mt-0 horizontal dark" />
    <sidenav-list />
  </aside>
</template>

<style scoped>
.bg-dark {
  background: linear-gradient(to top, rgba(2, 31, 80, 0.7),rgba(52, 71, 103, 0.7)), url(../../assets/img/dash-bg.jpg) no-repeat bottom left !important;
  background-size: cover !important;
}
/* .bg-dark:after {
  background: rgba(39,62,84,0.82);
  overflow: hidden;
  height: 100%;
  z-index: 2;
} */
/* Des custom */
.nav-link.no-link-nav{
  background:#eee;
  border-radius: 5px;
	font-weight: 600 !important;
	cursor: default;	
}.nav-link.no-link-nav::after{
	display: none !important;
}
</style>